// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"RadioButton_checkbox__OkO_z","checkbox__input":"RadioButton_checkbox__input__QUAEn","checkbox__label":"RadioButton_checkbox__label__e4qZ8"};